// store/EmployeeStore.js
import { makeAutoObservable, runInAction } from 'mobx';

class EmployeeStore {
  employees = [];
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Устанавливаем user и auth
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  // Получить сотрудника по ID
  getEmployeeById(id) {
    return this.employees.find((obj) => Number(obj.id) === Number(id));
  }

  // Получить список сотрудников
  async fetchEmployees({ user = this.user, auth = this.auth } = {}) {
    if (!user || !auth) {
      console.warn('Нет auth или user для запроса к бэку');
      return;
    }

    this.loading = true;
    try {
      const res = await fetch('https://bitrixapi.tmg-din-reestr.ru/employees', {
        headers: {
          'X-Bitrix-User': user,
          'X-Bitrix-Auth': auth,
        },
      });
      if (!res.ok) throw new Error(`Ошибка HTTP ${res.status}`);
      const data = await res.json();

      runInAction(() => {
        this.employees = data.map((user) => ({
          id: Number(user.ID ?? user.id),
          xmlId: user.XML_ID,
          name: `${user.LAST_NAME ?? ''} ${user.NAME ?? user.name}`.trim(),
          email: user.EMAIL,
          workPosition: user.WORK_POSITION,
        }));
      });
    } catch (error) {
      console.error('Ошибка при загрузке сотрудников:', error);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // ===========================
  // Новый метод: поиск по имени
  // ===========================
  normalize(str) {
    return String(str ?? '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /**
   * Поиск сотрудника по имени/фамилии.
   * Можно вводить "Имя Фамилия", "Фамилия Имя", регистр неважен.
   * Возвращает id первого совпадения или null.
   */
  findEmployeeIdByName(input) {
    const normInput = this.normalize(input);

    for (const emp of this.employees) {
      const normName = this.normalize(emp.name); // "Иванов Иван"
      const [last, first] = normName.split(' '); // предполагаем "Фамилия Имя"

      const combos = [
        `${first} ${last}`, // "Имя Фамилия"
        `${last} ${first}`, // "Фамилия Имя"
        `${first}`,         // только имя
        `${last}`,          // только фамилия
        normName,           // полное "Фамилия Имя"
      ];
      //console.log(combos, last, first)
      if (combos.some(c => {console.log(combos, normInput); return c === normInput})) {
        console.log('нашли', normInput, emp.id)
        return emp.id;
      }
    }

    return null; // не найдено
  }
}

const employeeStore = new EmployeeStore();
export default employeeStore;
